import { Pagination, PaginationProps } from 'antd';
import { usePaginationA11y } from './usePaginationA11y';

export interface IPaginationA11yProps extends PaginationProps {
  hideTotal?: boolean;
}
/**
 * Wrapper del componente di Paginazione per inserire gli elementi per l'accessibulità.
 *
 * @param showSizeChanger Di default è visualizzato impostare a false per nasconderlo.
 * @param hideTotal Di default è visualizzato il totale degli elementi (showTotal)
 * impostare hideTotal a true per nasconderlo.
 */
export function PaginationA11y(props: IPaginationA11yProps) {
  const paginationBase = usePaginationA11y({ ...props }, props.hideTotal);

  return <Pagination {...paginationBase} />;
}
